// Built-ins
import React, { useState } from "react";

// Icons / Images
import { FiEdit2 } from "react-icons/fi";
import { BsInfoSquare } from "react-icons/bs";

// Modules / Functions
import { Modal, ListGroup, Spinner } from "react-bootstrap";
import { Button, Checkbox } from "semantic-ui-react";
import axios from "axios";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Swal from "sweetalert2";

// Global Variables
import { headers } from "../../../../global_vars";

// Custom Made Components
import AddCoachOperatorModal from "../../../../modals/create/add_coach_operator_modal";

// Variables
window.Swal = Swal;

const CHANGE_COACH_OPERATOR =
  "https://groupplan.gr/api/groups/change_coach_operator/";
const GET_COACH_OPERATORS = "https://groupplan.gr/api/view/get_all_coach_operators/";

function ChangeCoachOperator(props) {
  const [show, setShow] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [UpdateRestOfDays, setUpdateRestOfDays] = React.useState(false);

  const handleCheckBox = () => {
    setUpdateRestOfDays(!UpdateRestOfDays);
  };

  const [CoachOperator, setCoachOperator] = useState(
    props.coach_operator ? props.coach_operator : ""
  );
  let [AllCoachOperators, setAllCoachOperators] = useState([]);

  const updateCoachOperator = () => {
    props.updateIsLoaded();
    axios({
      method: "post",
      url: CHANGE_COACH_OPERATOR,
      headers: headers,
      data: {
        coach_operator: CoachOperator,
        td_id: props.td_id,
        update_rest_of_days: UpdateRestOfDays,
      },
    })
      .then((res) => {
        props.update_state(res.data.model);
        props.updateIsLoaded();
      })
      .catch((e) => {
        props.updateIsLoaded();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: e.response.data.errormsg,
        });
      });
  };

  const getCoachOperators = () => {
    axios
      .get(GET_COACH_OPERATORS, {
        headers: headers,
      })
      .then((res) => {
        setAllCoachOperators(res.data.all_coach_operators.map((coach_operator) => coach_operator.name));
        setLoaded(true);
      });
  };

  return (
    <>
      <FiEdit2
        title={"Edit Coach Operator"}
        id={"edit_refcode"}
        className={"edit_icon"}
        onClick={() => {
          handleShow();
          getCoachOperators();
        }}
      />
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Change Coach Operator For {props.group.refcode}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ListGroup>
            <ListGroup.Item>
              <Autocomplete
                options={AllCoachOperators}
                className={"select_airport"}
                onChange={(e) => {
                  setCoachOperator(e.target.innerText);
                }}
                value={CoachOperator}
                style={{ width: "40%", margin: 10 }}
                disabled={!loaded}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Coach Operator"
                    variant="outlined"
                  />
                )}
              />
              <div style={{ float: "right" }}>
                <AddCoachOperatorModal
                  redir={false}
                  set_coach_operator={(e) => setCoachOperator(e)}
                />
              </div>
              {loaded ? (
                ""
              ) : (
                <Spinner
                  animation="border"
                  variant="info"
                  size="sm"
                  style={{ position: "fixed", marginTop: 30 }}
                />
              )}
              <div style={{ marginTop: 20 }}>
                <Checkbox
                  label={"All upcoming days?"}
                  value={UpdateRestOfDays}
                  onChange={handleCheckBox}
                />
              </div>
            </ListGroup.Item>
          </ListGroup>
        </Modal.Body>
        <Modal.Footer>
          <small className="mr-auto">
            <BsInfoSquare
              style={{
                color: "#F3702D",
                fontSize: "1.5em",
                marginRight: "0.5em",
              }}
            />
            You can manage Coach Operator's data at
            <a href="/data_management/all_coach_operators"> Data management </a>
          </small>
          <Button color="red" onClick={handleClose}>
            Close
          </Button>
          <Button
            color="green"
            onClick={() => {
              handleClose();
              updateCoachOperator();
            }}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ChangeCoachOperator;
